/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction,
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GenerateWebTraderIframeRequest } from '../models';
// @ts-ignore
import { GenerateWebTraderIframeResponse } from '../models';
// @ts-ignore
import { GetCzDataRequest } from '../models';
// @ts-ignore
import { GetCzDataResponse } from '../models';
// @ts-ignore
import { GetRiskScoreRequest } from '../models';
// @ts-ignore
import { GetRiskScoreResponse } from '../models';
/**
 * WebTraderApi - axios parameter creator
 * @export
 */
export const WebTraderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {GenerateWebTraderIframeRequest} generateWebTraderIframeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGenerateWebTraderIframe: async (
            generateWebTraderIframeRequest: GenerateWebTraderIframeRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'generateWebTraderIframeRequest' is not null or undefined
            assertParamExists(
                'webTraderControllerGenerateWebTraderIframe',
                'generateWebTraderIframeRequest',
                generateWebTraderIframeRequest
            );
            const localVarPath = `/api/webTrader/generateWebTraderIframe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                generateWebTraderIframeRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GetCzDataRequest} getCzDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGetCzData: async (
            getCzDataRequest: GetCzDataRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'getCzDataRequest' is not null or undefined
            assertParamExists('webTraderControllerGetCzData', 'getCzDataRequest', getCzDataRequest);
            const localVarPath = `/api/webTrader/getCzData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                getCzDataRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GetRiskScoreRequest} getRiskScoreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGetRiskScore: async (
            getRiskScoreRequest: GetRiskScoreRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'getRiskScoreRequest' is not null or undefined
            assertParamExists('webTraderControllerGetRiskScore', 'getRiskScoreRequest', getRiskScoreRequest);
            const localVarPath = `/api/webTrader/getRiskScore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                getRiskScoreRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * WebTraderApi - functional programming interface
 * @export
 */
export const WebTraderApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = WebTraderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {GenerateWebTraderIframeRequest} generateWebTraderIframeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webTraderControllerGenerateWebTraderIframe(
            generateWebTraderIframeRequest: GenerateWebTraderIframeRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateWebTraderIframeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webTraderControllerGenerateWebTraderIframe(
                generateWebTraderIframeRequest,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {GetCzDataRequest} getCzDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webTraderControllerGetCzData(
            getCzDataRequest: GetCzDataRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCzDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webTraderControllerGetCzData(
                getCzDataRequest,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {GetRiskScoreRequest} getRiskScoreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webTraderControllerGetRiskScore(
            getRiskScoreRequest: GetRiskScoreRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRiskScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webTraderControllerGetRiskScore(
                getRiskScoreRequest,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};

/**
 * WebTraderApi - factory interface
 * @export
 */
export const WebTraderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebTraderApiFp(configuration);
    return {
        /**
         *
         * @param {GenerateWebTraderIframeRequest} generateWebTraderIframeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGenerateWebTraderIframe(
            generateWebTraderIframeRequest: GenerateWebTraderIframeRequest,
            options?: any
        ): AxiosPromise<GenerateWebTraderIframeResponse> {
            return localVarFp
                .webTraderControllerGenerateWebTraderIframe(generateWebTraderIframeRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetCzDataRequest} getCzDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGetCzData(
            getCzDataRequest: GetCzDataRequest,
            options?: any
        ): AxiosPromise<GetCzDataResponse> {
            return localVarFp
                .webTraderControllerGetCzData(getCzDataRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetRiskScoreRequest} getRiskScoreRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webTraderControllerGetRiskScore(
            getRiskScoreRequest: GetRiskScoreRequest,
            options?: any
        ): AxiosPromise<GetRiskScoreResponse> {
            return localVarFp
                .webTraderControllerGetRiskScore(getRiskScoreRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebTraderApi - object-oriented interface
 * @export
 * @class WebTraderApi
 * @extends {BaseAPI}
 */
export class WebTraderApi extends BaseAPI {
    /**
     *
     * @param {GenerateWebTraderIframeRequest} generateWebTraderIframeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebTraderApi
     */
    public webTraderControllerGenerateWebTraderIframe(
        generateWebTraderIframeRequest: GenerateWebTraderIframeRequest,
        options?: any
    ) {
        return WebTraderApiFp(this.configuration)
            .webTraderControllerGenerateWebTraderIframe(generateWebTraderIframeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {GetCzDataRequest} getCzDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebTraderApi
     */
    public webTraderControllerGetCzData(getCzDataRequest: GetCzDataRequest, options?: any) {
        return WebTraderApiFp(this.configuration)
            .webTraderControllerGetCzData(getCzDataRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {GetRiskScoreRequest} getRiskScoreRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebTraderApi
     */
    public webTraderControllerGetRiskScore(getRiskScoreRequest: GetRiskScoreRequest, options?: any) {
        return WebTraderApiFp(this.configuration)
            .webTraderControllerGetRiskScore(getRiskScoreRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
